function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".st0{fill:#ffffff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M310.56,441.23c-2.52,0-5-1.68-6.72-3.35L188,271.69,5.88,212.09C2.52,211.25,0,207.9,0,203.7a8.07,8.07,0,0,1,5.88-7.56L493.53,63.53c3.36-.84,6.72,0,8.4,2.52a9,9,0,0,1,.84,9.23L317.27,436.2c-.84,3.35-3.35,5-6.71,5ZM37.77,205.38l157.8,51.2c1.68.84,3.35,1.68,4.19,3.35L308.88,416.05,479.27,85.35Z",
  transform: "translate(0 -62.95)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M193.05,273.36c-2.52,0-5.88-1.67-6.72-4.19-2.51-4.2-1.68-9.24,2.52-11.75L491,64.37c4.19-2.52,9.23-1.68,11.75,2.52s1.68,9.23-2.52,11.75l-302.16,193A11.94,11.94,0,0,1,193.05,273.36Z",
  transform: "translate(0 -62.95)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M176.26,407.66a7.57,7.57,0,0,1-4.2-.84,10.35,10.35,0,0,1-4.19-8.39l16.78-134.3a9.12,9.12,0,0,1,6.72-6.71c3.36-.84,6.71.84,9.23,3.35l55.4,78.9c2.52,3.36,1.68,8.4-1.68,11.75l-72.18,55.4C179.62,406.82,177.94,407.66,176.26,407.66Zm22.67-120L187.17,380.8,236.69,343Z",
  transform: "translate(0 -62.95)"
});

var SvgIconPlaceOrder = function SvgIconPlaceOrder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 504.18 378.28",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconPlaceOrder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_place_order.06c710b8.svg";
export { ForwardRef as ReactComponent };